"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,0.995397568 L1,0.995397568 L1,9.00460243 C1,8.99547184 1.00452889,9 1.00247329,9 L10.9975267,9 C10.9969864,9 11,8.99702192 11,9.00460243 L11,0.995397568 C11,1.00452816 10.9954711,1 10.9975267,1 L1.00247329,1 C1.00301359,1 1,1.00297808 1,0.995397568 L1,0.995397568 Z M0,0.995397568 C0,0.445654671 0.455760956,0 1.00247329,0 L10.9975267,0 C11.5511774,0 12,0.455664396 12,0.995397568 L12,9.00460243 C12,9.55434533 11.544239,10 10.9975267,10 L1.00247329,10 C0.448822582,10 0,9.5443356 0,9.00460243 L0,0.995397568 Z M1,9 L4.37213897,5.5 L6.23835906,7.35893955 L7.7954357,5.80793741 L11,9 L1,9 Z M8.5,4.5 C9.05228475,4.5 9.5,4.05228475 9.5,3.5 C9.5,2.94771525 9.05228475,2.5 8.5,2.5 C7.94771525,2.5 7.5,2.94771525 7.5,3.5 C7.5,4.05228475 7.94771525,4.5 8.5,4.5 Z"
  }));
};

exports["default"] = _default;